import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { webinarListsByPageQueryKey } from '@/entities/Webinars'

export const deleteWebinar = async (webinarId: number) => {
  const response = await topliApi.webinars.delete(webinarId)
  return response
}

export const useDeleteWebinarApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteWebinar(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [webinarListsByPageQueryKey],
        refetchType: 'active',
      })
    },
  })
}
